var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-decorative"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 21.5011C6.41073 20.7294 6.90165 20.0728 7.69175 19.7028C8.75395 19.2054 9.76294 19.4135 10.7063 20.0196C11.6626 20.634 12.2917 21.517 12.8006 22.4855C13.0528 22.9656 13.2699 23.4627 13.5163 23.9802C13.5967 23.8945 13.6733 23.814 13.7487 23.7326C15.9776 21.327 18.2494 18.9609 20.7058 16.7664C22.7735 14.9191 24.9575 13.2159 27.4003 11.8429C29.1732 10.8464 31.0375 10.0506 33.0381 9.58227C33.3005 9.52085 33.5952 9.55915 33.8709 9.58809C34.0475 9.60664 34.0164 9.75475 33.9342 9.8482C33.8162 9.98229 33.6863 10.1145 33.5376 10.2147C30.0449 12.5698 26.868 15.2741 23.9469 18.2606C20.3739 21.9136 17.266 25.9082 14.5396 30.1813C14.1109 30.8533 13.7032 31.5378 13.2924 32.2202C13.1669 32.4287 13.0016 32.5647 12.7447 32.5481C12.4856 32.5313 12.3509 32.3734 12.2614 32.1448C11.4834 30.158 10.7246 28.1635 9.90463 26.1928C9.46101 25.1266 8.92577 24.0943 8.39642 23.0636C8.2329 22.7452 7.97836 22.4586 7.72001 22.1996C7.26783 21.7462 6.69518 21.5142 6 21.5011Z",
    fill: "#F0EAD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolCheck);
export default __webpack_public_path__ + "static/media/symbol-check.be9a6597ddceca82b401a9f50e50cd28.svg";
export { ForwardRef as ReactComponent };